import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import SearchSites from '../site/SearchSites';
import Documents from './Documents';
import InfoMessages from './InfoMessages';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';

export default function Home(_props: RouteComponentProps<{}>) {
    return (
        <Grid container spacing={3}>
            <Grid size={{ xs: 12, md: 8 }}>
                <SearchSites />
            </Grid>
            <Grid size={{ xs: 12, md: 4 }}>
                <InfoMessages />
                <Box sx={{ mt: 9 }}>
                    <Documents />
                </Box>
            </Grid>
        </Grid>
    );
}
